import type { ForecastTableControlValues } from "../components/tableControls/forecastTableControlValues";

/**
 * Weekly column keys W01–W53. Shared across column definitions,
 * intake caching, transactional data extraction, and graph constants.
 */
export const WEEKLY_KEYS = Array.from(
  { length: 53 },
  (_, i) => `W${String(i + 1).padStart(2, "0")}`
);

/** Monthly column keys M01–M12. */
export const MONTHLY_KEYS = Array.from(
  { length: 12 },
  (_, i) => `M${String(i + 1).padStart(2, "0")}`
);

/** Quarterly column keys Q1–Q4. */
export const QUARTERLY_KEYS = ["Q1", "Q2", "Q3", "Q4"];

/** Half-year column keys H1–H2. */
export const HALF_YEAR_KEYS = ["H1", "H2"];

/**
 * Display label for a period key: the fiscal key itself when the key is
 * weekly (``W##``) and Fiscal week labels are active (DAS-6481), otherwise
 * the calendar label resolved via ``gregMapping``.
 */
export function resolvePeriodLabel(
  key: string,
  weekLabels: ForecastTableControlValues["weekLabels"],
  gregMapping: Record<string, string> | undefined
): string {
  return weekLabels === "Fiscal" && key.startsWith("W")
    ? key
    : (gregMapping?.[key] ?? key);
}

/** Time period column keys for each granularity. Returns null for PTG (no chart/column). */
export function getTimePeriodKeys(
  timePeriod: ForecastTableControlValues["timePeriod"]
): string[] | null {
  switch (timePeriod) {
    case "WK":
      return WEEKLY_KEYS;
    case "MO":
      return MONTHLY_KEYS;
    case "QTR":
      return QUARTERLY_KEYS;
    case "HY":
      return HALF_YEAR_KEYS;
    default:
      return null;
  }
}
